import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const ReviewCarousel = ({ reviews }) => {
    return (
        <div className="p-3">
            {reviews.length > 0 ? (
                <Swiper
                    modules={[Pagination, Navigation]}
                    spaceBetween={20}
                    slidesPerView={1}
                    navigation
                    pagination={{ clickable: true }}
                    className="w-full max-w-lg"
                >
                    {reviews.map((review) => (
                        <SwiperSlide key={review._id}>
                            <div className="p-4 border rounded-lg shadow-md bg-white text-center">
                                <div className="flex justify-center space-x-1 mb-2 text-2xl">
                                   {[...Array(review.rating)].map((_, index) => (
                                    <span key={index} className="text-yellow-500">★</span>
                                    ))} 
                                   
                                </div>
                                <p className="text-gray-700">{review.note}</p>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            ) : (
                <p>No reviews available for this product.</p>
            )}
        </div>
    );
};

export default ReviewCarousel;
